import React from "react";
import moment from "moment";
import { findClinician, getFullName } from "../../../../util/helpers";

const PatientDiagnosisTable = ({ clinician, diagnosisData, staffData }) => {
  const getClinician = (item) => {
    if (item?.added_by === clinician?.id) {
      return getFullName(clinician);
    } else {
      return getFullName(findClinician(staffData, item?.added_by));
    }
  };
  return (
    <div className="container-fluid diagnosis-table-container">
      <table className="table my-3 px-2">
        <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
          <tr
            style={{
              height: "4rem",
              verticalAlign: "middle",
            }}
          >
            <th scope="col">
              <span className="muted-text">BH Diagnosis</span>
            </th>
            <th scope="col">
              <span className="muted-text">Notes</span>
            </th>
            <th scope="col">
              <span className="muted-text">Updated On</span>
            </th>
            <th scope="col">
              <span className="muted-text">Updated By</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {diagnosisData?.length > 0 &&
            diagnosisData?.slice(0, 5)?.map((item) => {
              return (
                <tr key={item?.id}>
                  <th scope="row">
                    <small>{item?.diagnosis}</small>
                  </th>
                  <td>
                    <small>{item?.notes}</small>
                  </td>
                  <td>
                    <small>{moment(item?.modified).format("MM/DD/YYYY")}</small>
                  </td>
                  <td>
                    <small>{getClinician(item)}</small>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default PatientDiagnosisTable;
